import c from 'classnames';
import { useCallback } from 'react';
import { toast } from 'react-toastify';

import { capitalize, copyToClipboard } from '@repo/utils';
import { Icon } from '../Icon/Icon';

import styles from './CopyField.module.css';

type CopyFieldVariant = 'input' | 'icon';

interface CopyFieldProps {
  value: string;
  name: string;
  onCopy?: (value: string, name: string) => void;
  /**
   * `input` (default) renders a bordered, input-like field. `icon` drops the
   * border and renders just the text with a purple copy icon to the right.
   */
  variant?: CopyFieldVariant;
}

export const CopyField = ({
  value,
  name,
  onCopy,
  variant = 'input',
}: CopyFieldProps) => {
  const copyCodeToClipboard = useCallback(() => {
    if (!value) return;
    copyToClipboard(value);
    toast.success(`${capitalize(name)} copied to clipboard`);
    onCopy?.(value, name);
  }, [name, onCopy, value]);

  return (
    <div className={c(styles.copyField, styles[variant])}>
      <span className={styles.value} title={value}>
        {value}
      </span>
      <>
        <label htmlFor='copy-button' className='hidden'>
          Copy {name}
        </label>
        <button
          id='copy-button'
          className={styles.copyIcon}
          onClick={copyCodeToClipboard}
        >
          <Icon name='copy' size={variant === 'icon' ? 's' : 'm'} />
        </button>
      </>
    </div>
  );
};
